/** Hub filter pills for the /use-cases index — slugs are matched via `hubCategory` on each use case. */
export const USE_CASE_HUB_CATEGORIES = [
  { label: 'All', value: 'all' },
  { label: 'Creative', value: 'creative' },
  { label: 'Business', value: 'business' },
  { label: 'Technical', value: 'technical' },
  { label: 'Education', value: 'education' },
  { label: 'Values', value: 'values' },
  { label: 'Lifestyle', value: 'lifestyle' },
];

export default USE_CASE_HUB_CATEGORIES;
